module.exports = __webpack_public_path__ + "assets/img/Join.e1cdd4ca.svg";